<template>
  <div class="configurator" id="configurator">
    <h2 class="h2 text-align-left">
      Konfigurator
      <small v-if="step == 3">{{ system.cfg.name }}</small>
    </h2>
    <div
      v-if="step == 1"
      @submit.prevent.prevent=""
      @mouseleave="(activeX = -1), (activeY = -1)"
      @mouseover="(activeX = -1), (activeY = -1)"
    >
      <div :class="{ step1: true, collapsed: step1Collapsed }">
        <div class="left">
          <div class="t-head"></div>
          <div class="r-head">
            <div
              class="num"
              @click="step1Collapsed = !step1Collapsed"
              style="cursor: pointer"
            >
              {{ step1Collapsed ? ">>" : "<<" }}
            </div>
            <div class="name">nazwa pomieszczenia</div>
            <div class="kind">
              <i class="info" @click.prevent="showHelp('types')">i</i> rodzaj
              wkładki
            </div>
            <div class="depth">
              <i class="info" @click.prevent="showHelp('sizes')">i</i> długość
              <div class="r">
                <div class="middle">zewn.</div>
                <div class="middle">wewn.</div>
              </div>
            </div>
            <div class="qty">
              ilość
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <div class="r">
                <div class="middle inserts">wkładek</div>
                <div class="middle individual">
                  kluczy <br />
                  indywidualnych
                </div>
              </div>
            </div>
          </div>
          <div
            :class="'r-row ' + (i == activeY ? 'active' : '')"
            @mouseover.prevent.stop="
              activeY = i;
              activeX = -2;
            "
            v-for="(k, i) in model.keys"
            :key="'lk' + i"
          >
            <div class="num">
              {{ parseInt(i) + 1 }}
            </div>
            <div class="name">
              <input type="text" placeholder="nazwa" v-model="k.name" />
            </div>
            <div class="kind">
              <select v-model="k.kind">
                <option
                  v-for="(cfg, kind) in kinds"
                  :key="'lk' + i + kind"
                  :value="kind"
                >
                  {{ cfg.name }}
                </option>
              </select>
            </div>
            <div class="depth">
              <div class="r">
                <span class="middle sizes">
                  <select v-model="k.cyl1" :disabled="!kinds[k.kind].cyl1">
                    <option v-for="i in sizes" :key="i" :value="i">
                      {{ i }}
                    </option>
                  </select>
                </span>
                <span class="middle sizes">
                  <select v-model="k.cyl2" :disabled="!kinds[k.kind].cyl2">
                    <option v-for="i in sizes" :key="'2' + i" :value="i">
                      {{ i }}
                    </option>
                  </select>
                </span>
              </div>
            </div>
            <div class="qty">
              <div class="r">
                <div class="middle inserts">
                  <a href="#" class="left" @click.prevent="qty(i, -1)">-</a>
                  <span class="middle"
                    ><input type="number" min="0" v-model="k.qty"
                  /></span>
                  <a href="#" class="right" @click.prevent="qty(i, 1)">+</a>
                </div>
                <div class="middle individual">
                  <a href="#" class="left" @click.prevent="qtyInd(i, -1)">-</a>
                  <span class="middle"
                    ><input
                      type="number"
                      placeholder="brak"
                      min="0"
                      v-model="k.ind"
                  /></span>
                  <a href="#" class="right" @click.prevent="qtyInd(i, 1)">+</a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="middle">
          <div class="t-head">Klucze</div>
          <div class="r-head">
            <div
              v-for="(val, i) in model.variants"
              :key="'v' + i"
              :class="'variant' + (i == activeX ? ' active' : '')"
              @mouseover.prevent.stop="
                activeX = i;
                activeY = -2;
              "
            >
              <span class="gear">
                <input
                  type="text"
                  placeholder="nazwa"
                  class="txt name"
                  v-model="val.name"
                />
              </span>
              <span class=""
                ><input
                  type="text"
                  placeholder="symbol"
                  v-model="val.symbol"
                  class="txt"
              /></span>
              <div class="r">
                <a href="#" class="left" @click.prevent="variantCount(i, -1)"
                  >-</a
                >
                <span class="middle"
                  ><input type="number" min="0" v-model="val.qty"
                /></span>
                <a href="#" class="right" @click.prevent="variantCount(i, 1)"
                  >+</a
                >
              </div>
            </div>
          </div>
          <div class="r-row" v-for="(k, i) in model.keys" :key="'rk' + i">
            <label
              v-for="(val, a) in model.variants"
              :key="'rkk' + i + a"
              :class="
                'variant' +
                ((activeX == a || activeX == -2) &&
                (activeY == i || activeY == -2)
                  ? ' active'
                  : '')
              "
              @mouseover.prevent.stop="(activeX = a), (activeY = i)"
            >
              <input type="checkbox" v-model="model.keys[i].variants[a]" />
            </label>
          </div>
        </div>
        <div class="right">
          <div class="t-head"></div>
          <div class="r-head">
            <div class="btns">
              <a href="#" @click.prevent="removeCol">-</a>
              <a href="#" @click.prevent="addCol">+</a>
            </div>
          </div>
        </div>
      </div>
      <br />
      <div class="r">
        <div class="middle">
          <div class="btns">
            <a href="#" @click.prevent="removeRow">-</a>
            <a href="#" @click.prevent="addRow">+</a>
          </div>
        </div>
        <div class="right" style="text-align: right">
          <a href="#" class="btn" @click.prevent="prepareIndividual(-1)">-</a>
          klucze indywidualne
          <a href="#" class="btn" @click.prevent="prepareIndividual(+1)">+</a>

          <a href="#" class="btn" @click.prevent="saveModel" v-if="!admin"
            >zapisz</a
          >
          <a href="#" class="btn" @click.prevent="generateShareLink"
            >generuj link</a
          >
          <a href="#configurator" class="btn" @click="step2" v-if="!admin"
            >zobacz kalkulacje</a
          >
        </div>
      </div>
    </div>
    <div v-else-if="step == 2">
      <div class="system-table">
        <div class="header system">
          <div class="photo"></div>
          <div class="name">System</div>
          <div class="description">Opis</div>
          <div class="time">Czas realizacji</div>
          <div class="price">Cena netto</div>
          <div class="action"></div>
        </div>
        <div class="r system" v-for="prod in systems" :key="prod.cfg.id">
          <div class="photo">
            <img :src="prod.photo" alt="" v-if="prod.cfg.photo" />
          </div>
          <div class="name">
            <a :href="prod.cfg.url" target="_BLANK">{{ prod.cfg.name }}</a>
          </div>
          <div class="description" v-html="prod.cfg.short"></div>
          <div class="time">{{ prod.cfg.cfg.lead_time || "2 tyg." }}</div>
          <div class="price">{{ prod.price | price }} zł</div>
          <div class="action">
            <a href="#configurator" @click="step3(prod.cfg)" class="btn"
              >konfiguracja</a
            >
          </div>
        </div>
      </div>
      <div class="r">
        <div class="left">
          <a href="#configurator" class="btn" @click="step1">powrót</a>
        </div>
        <div class="middle">
          <div class="btns"></div>
        </div>
      </div>
    </div>
    <div v-else-if="step == 3" class="step3">
      <div class="key-table">
        <div class="header">
          <div class="pos">Lp.</div>
          <div class="name">Element</div>
          <div class="conf">Konfiguracja</div>
          <div class="price">Cena za sztukę</div>
          <div class="price">Razem</div>
          <div class="action">Zamówienie</div>
        </div>
        <div class="sub-row">Wkładka</div>
        <div
          class="r insert"
          v-for="(insert, i) in system.inserts"
          :key="'i' + i"
        >
          <div class="pos">{{ parseInt(i) + 1 }}</div>
          <div class="name">
            <span>{{ kinds[insert.kind].name }}</span
            ><br />
            <strong>{{ insert.name }}</strong
            ><br />
            ilość wkładek:
            <input
              type="number"
              class="qty"
              v-model="insert.qty"
              @change="calcAllPrice"
              @input="calcAllPrice"
            /><br />
            <small
              >{{ insert.reference
              }}{{ kinds[insert.kind].cyl1 ? "-" + insert.cyl1 : ""
              }}{{ kinds[insert.kind].cyl2 ? "/" + insert.cyl2 : "" }}</small
            >
            <br />
          </div>
          <div class="conf">
            <table>
              <thead>
                <tr>
                  <th class="param">Parametr</th>
                  <th class="value">Wartość</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="kinds[insert.kind].cyl1">
                  <td class="param">Głębokość zewnętrzna</td>
                  <td class="value">{{ insert.cyl1 }}mm</td>
                </tr>
                <tr v-if="kinds[insert.kind].cyl2">
                  <td class="param">Głębokość wewnętrzna</td>
                  <td class="value">{{ insert.cyl2 }}mm</td>
                </tr>
                <tr>
                  <td class="param">Klucze indywidualne</td>
                  <td class="value">
                    <span class="ind-qty">
                      ilość:
                      <input
                        type="number"
                        class="qty"
                        placeholder="brak"
                        v-model="insert.ind"
                        @change="calcAllPrice"
                        @input="calcAllPrice"
                      />
                    </span>
                  </td>
                </tr>
                <template v-if="system.cfg.cfg.params.length > 0">
                  <tr>
                    <th colspan="2">
                      <strong class="extra">Opcje płatne dodatkowo </strong>
                    </th>
                  </tr>
                  <tr
                    v-for="(param, p) in system.cfg.cfg.params"
                    :key="p + 'i' + i"
                  >
                    <td class="param">
                      <i
                        class="info"
                        @click="showInfo(param.descriptionId)"
                        v-if="
                          param.descriptionId &&
                          helps.descriptions[param.descriptionId]
                        "
                        >i</i
                      >
                      {{ param.name }}
                    </td>
                    <td class="value">
                      <template v-if="enabledValues(insert, param)">
                        <ul v-if="param.multiple">
                          <li
                            v-for="(pv, pp) in enabledValues(insert, param)"
                            :key="p + 'i' + i + pp"
                          >
                            <label
                              ><input
                                type="checkbox"
                                @change="calcAllPrice"
                                :value="pv.symbol"
                                v-model="insert.params[p]"
                              />
                              {{ pv.name }} +{{ pv.price | price }} zł</label
                            >
                          </li>
                        </ul>
                        <select
                          v-else
                          v-model="insert.params[p]"
                          @change="calcAllPrice"
                        >
                          <option :value="null">standard</option>
                          <option
                            v-for="(pv, pp) in enabledValues(insert, param)"
                            :key="p + 'i' + i + pp"
                            :value="pv.symbol"
                          >
                            {{ pv.name }} +{{ pv.price | price }} zł
                          </option>
                        </select>
                      </template>
                      <span v-else>-</span>
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
          <div class="price">{{ insert.price | price }} zł</div>
          <div class="price">{{ (insert.price * insert.qty) | price }} zł</div>
          <div class="action">
            <input
              type="checkbox"
              v-model="insert.order"
              @change="calcAllPrice"
            />
          </div>
        </div>
        <div class="sub-row">Klucze indywidualne</div>
        <div
          class="r key key-indyvidual"
          v-for="(insert, i) in system.inserts"
          v-if="insert.order"
          :key="'ik' + i"
        >
          <div class="pos">{{ parseInt(i) + 1 }}</div>
          <div class="name">
            <span>{{ kinds[insert.kind].name }}</span
            ><br />
            <strong>{{ insert.name }}</strong
            ><br />
            <small
              >{{ insert.reference
              }}{{ kinds[insert.kind].cyl1 ? "-" + insert.cyl1 : ""
              }}{{ kinds[insert.kind].cyl2 ? "/" + insert.cyl2 : "" }}</small
            >
          </div>
          <div class="conf">
            <div class="key-header" v-if="i == 0">
              <div class="pos">Ilość</div>
              <div class="name">Nazwa</div>
            </div>
            <div class="key-row">
              <div class="pos">
                <input
                  type="number"
                  class="qty"
                  placeholder="brak"
                  v-model="insert.ind"
                  @change="calcAllPrice"
                  @input="calcAllPrice"
                />
              </div>
              <div class="name">
                {{ system.cfg.cfg.keys[0].name }}
              </div>
            </div>
          </div>
          <div class="price">{{ insert.indPrice | price }} zł</div>
          <div class="action">
            <input
              type="checkbox"
              disabled
              v-model="insert.order"
              @change="calcAllPrice"
            />
          </div>
        </div>
        <div class="sub-row">Klucze grupowe</div>
        <div class="r key" v-for="(key, i) in system.keys" :key="'k' + i">
          <div class="pos">{{ parseInt(i) + 1 }}</div>
          <div class="name">
            <strong>{{ key.symbol }}</strong
            ><br />
            <i v-if="key.name">{{ key.name }}<br /></i>
            {{ calcKeyQty(key) }} szt<br />
            <small>{{ key.reference }}</small>
          </div>
          <div class="conf">
            <div class="key-header">
              <div class="pos">Ilość</div>
              <div class="name">Nazwa</div>
              <div class="price">Cena</div>
            </div>
            <div
              class="key-row"
              v-for="(keycfg, a) in system.cfg.cfg.keys"
              :key="i + 'kc' + a"
            >
              <div class="pos">
                <input
                  type="number"
                  min="0"
                  @change="calcAllPrice"
                  v-model="key.variants[a]"
                  @input="calcAllPrice"
                  class="qty"
                />
              </div>
              <div class="name">
                {{ keycfg.name }}
              </div>
              <div class="price">{{ keycfg.price | price }} zł</div>
            </div>
          </div>
          <div class="price">{{ key.price | price }} zł</div>
          <div class="action">
            <input type="checkbox" v-model="key.order" @change="calcAllPrice" />
          </div>
        </div>
        <div class="sub-row">
          Przed zamówieniem sprawdź dokładnie swój projekt. <br />

          Cena za zestaw: <strong>{{ system.price | price }} zł</strong> + VAT
        </div>
      </div>
      <div class="r">
        <div class="left">
          <a href="#configurator" class="btn" @click="(step = 2), refreshHelp()"
            >powrót</a
          >
        </div>
        <div class="right">
          <div class="btns">
            <a href="#" @click.prevent="systemOrder()" class="btn">zamów</a>
          </div>
        </div>
      </div>
    </div>
    <modal v-if="error" @exit="error = null"
      ><div class="error">{{ error }}</div></modal
    >

    <modal v-if="saveAs" @exit="saveAs = false">
      <template v-slot:header>
        <h2 v-if="configName">Aktualizuj</h2>
        <h2 v-else>Zapisz jako</h2>
      </template>
      <template v-slot:default>
        <label>Nazwa</label>
        <input
          type="text"
          v-model="saveAsName"
          placeholder="Twoja nazwa"
          required
        />
      </template>
      <template v-slot:footer>
        <a href="#" class="btn" @click.prevent="saveAs = false">anuluj</a>
        <a href="#" class="btn" @click.prevent="saveUser()" v-if="saveAsName"
          >zapisz</a
        >
      </template>
    </modal>

    <modal v-if="info" @exit="info = null" class="info-modal">
      <template v-slot:header>
        <h2>{{ info.name }}</h2>
      </template>
      <template v-slot:default>
        <div classs="text" v-html="info.lead"></div>
        <template v-if="info.content">
          <hr />
          <div classs="text" v-html="info.content"></div>
        </template>
      </template>
      <template v-slot:footer>
        <a href="#" class="btn" @click.prevent="info = false">ok</a>
      </template>
    </modal>
  </div>
</template>
<script>
import modal from "./Modal.vue";
import axios from "axios";
export default {
  props: ["source", "admin", "customer", "configName"],
  name: "configurator",
  components: { modal },
  mounted() {},
  data() {
    let model = null;
    try {
      model = JSON.parse(this.source || "{}");
    } catch (e) {}
    let insertsNum = 10;
    let insertsVariants = 10;
    if (model && model.variants) {
      if (Array.isArray(model.variants)) {
        let tmp = {};
        for (let i in model.variants) {
          tmp[i] = model.variants[i];
        }
        model.variants = tmp;
      }
      if (Array.isArray(model.keys)) {
        let tmp = {};
        for (let i in model.keys) {
          tmp[i] = model.keys[i];
          tmp[i].ind = tmp[i].ind || null;
        }
        model.keys = tmp;
      }
      insertsNum = Object.keys(model.keys).length;
      insertsVariants = Object.keys(model.variants).length;
      model = this.generateModel(model, insertsNum, insertsVariants);
    } else {
      model = this.generateModel({}, 10, 10);
    }
    //this.$nextTick(this.refreshModel);
    return {
      insertsNum: insertsNum,
      insertsVariants: insertsVariants,
      activeX: -1,
      activeY: -1,
      error: null,
      step1Collapsed: false,
      step: 1,
      model: model,
      helps: {
        types: {
          name: "Rodzaj wkładki",
          content: document.getElementById("configurator-types").innerHTML,
        },
        sizes: {
          name: "Rozmiar wkładki",
          content: document.getElementById("configurator-sizes").innerHTML,
        },
      },
      saveAs: false,
      saveAsName: this.configName,
      cfg: {},
      info: null,
      system: null,
      kinds: {
        double_cylinder: {
          name: "Wkładka dwustronna",
          cyl1: true,
          cyl2: true,
        },
        half_cylinder: {
          name: "Półwkładka",
          cyl1: true,
        },
        knob_cylinder: {
          name: "Wkładka z gałką",
          cyl1: true,
          cyl2: true,
        },
        topcoat: {
          name: "Wkładka nawierzchniowa",
        },
        lock: {
          name: "Kłódka",
        },
        scandinavian_outdoor: {
          name: "Skandynawska zewnętrzna",
        },
        scandinavian_double: {
          name: "Skandynawska dwustronna",
        },
        activation_kit: {
          name: "Zestaw aktywacyjny / oprogramowanie",
        },
      },
    };
  },
  computed: {
    sizes() {
      let r = [];
      for (let i = 30; i <= 75; i += 5) {
        r.push(i);
      }

      return r;
    },
    systems() {
      if (!this.cfg || !this.cfg.systems) {
        return [];
      }
      let res = [];
      this.cfg.systems.forEach((cfg) => {
        let system = this.prepareSystem(cfg);
        this.calcAllPrice(system);
        res.push(system);
      });
      return res.sort((a, b) => {
        if (a.price - b.price == 0) {
          return a.cfg.name.localeCompare(b.cfg.name);
        }
        return a.price - b.price;
      });
    },
  },
  watch: {
    model: {
      deep: true,
      handler() {
        if (this.admin) {
          document.getElementById("key_config_value").value = JSON.stringify(
            this.model
          );
        }
      },
    },
  },
  methods: {
    showInfo(id) {
      this.info = this.helps.descriptions[id];
    },
    showHelp(help) {
      this.info = this.helps[help];
    },
    saveModel() {
      if (!this.customer) {
        this.error = "Zaloguj się";
        return;
      }
      this.saveAs = true;
      if (!this.configName) {
        this.saveAsName = null;
      }
    },
    generateShareLink() {
      const json = JSON.stringify(this.model);
      const preset = btoa(encodeURIComponent(json).replace(/%([0-9A-F]{2})/gi, (_, p1) => String.fromCharCode(parseInt(p1, 16))));
      const url = window.location.origin + window.location.pathname + '?preset=' + encodeURIComponent(preset);
      if (navigator.clipboard) {
        navigator.clipboard.writeText(url).then(() => {
          this.error = "Link skopiowany do schowka!";
        }).catch(() => {
          this.shareLinkUrl = url;
        });
      } else {
        this.shareLinkUrl = url;
      }
    },
    saveUser() {
      axios
        .post(window.location, {
          step: "save",
          model: JSON.stringify(this.model),
          name: this.saveAsName,
        })
        .then((resp) => {
          this.saveAs = false;
          this.error = "Zapisano pomyślnie";
        })
        .catch((e) => {
          if (e.response && e.response.data.message) {
            this.error = e.response.data.message;
          } else {
            this.error = "Błąd połączenia";
          }
        });
    },
    enabledValues(insert, param) {
      let res = [],
        ex = [this.system.cfg.kinds[insert.kind].symbol];

      this.system.cfg.cfg.params.forEach((test, i) => {
        let v = insert.params[i];
        if (!v) {
          return;
        }
        ex.push(v);
      });

      if (ex.length == 0) {
        return param.values;
      }
      param.values.forEach((v) => {
        let ignore = false;
        v.exclude.split(",").forEach((e) => {
          e = e.trim();
          if (e != "" && ex.includes(e)) {
            ignore = true;
          }
        });
        if (!ignore) {
          res.push(v);
        }
      });

      return res;
    },
    paramSelected(insert, param, p) {
      let v = insert.params[p];
      let ex = [];
      param.values.forEach((val) => {
        if (v == val.symbol) {
          val.exclude.split(",").forEach((e) => {
            e = e.trim();
            if (e != "") {
              ex.push(e);
            }
          });
        }
      });
      if (ex.length > 0) {
        for (var i in insert.params) {
          if (ex.includes(insert.params[i])) {
            insert.params[i] = null;
          }
        }
      }
    },
    calcAllPrice(system) {
      if (!system || !system.cfg || !system.inserts) {
        system = this.system;
      }
      let sum = 0;
      let packed = 0;

      for (var i in system.inserts) {
        let insert = system.inserts[i];
        insert.price = this.calcInsertPrice(system, insert, 1);
        insert.reference = this.calcInsertSymbol(insert, system);
        if (insert.order) {
          insert.qty = parseInt(insert.qty);
          if (insert.qty < 1) {
            continue;
          }
          sum += insert.price * insert.qty;

          for (var k in system.cfg.cfg.keys) {
            packed += parseInt(system.cfg.cfg.keys[k].packed) * insert.qty;
          }
        }
      }

      for (var i in system.inserts) {
        let insert = system.inserts[i];
        insert.price = this.calcInsertPrice(system, insert, 1);
        insert.reference = this.calcInsertSymbol(insert, system);
        if (insert.order) {
          if (insert.qty < 1) {
            continue;
          }
          if (insert.ind !== null && insert.ind > 0) {
            insert.ind = parseInt(insert.ind);
            let indKeys = insert.qty * insert.ind;
            insert.indPrice = 0;
            if (packed >= indKeys) {
              packed -= indKeys;
            } else {
              indKeys -= packed;
              sum += insert.indPrice =
                parseFloat(system.cfg.cfg.keys[0].price) * indKeys;
              packed = 0;
            }
          }
        }
      }

      for (var a in system.keys) {
        system.keys[a].reference = this.calcKeySymbol(system.keys[a], system);
        if (system.keys[a].order) {
          for (var k in system.keys[a].variants) {
            let key = system.cfg.cfg.keys[k];
            if (!key) {
              continue;
            }
            let enabled = system.keys[a].variants[k];
            enabled = parseInt(enabled) || 0;
            if (enabled <= 0) {
              continue;
            }
            let price = parseFloat(key.price);
            if (enabled >= packed) {
              enabled -= packed;
              packed = 0;
            } else {
              packed -= enabled;
              enabled = 0;
            }
            system.keys[a].price = enabled * price;
            sum += enabled * price;
          }
        } else {
          system.keys[a].price = 0;
        }
      }
      system.price = sum;
    },
    calcInsertPrice(system, insert, qty) {
      qty = parseInt(qty);
      let cfg = system.cfg.kinds[insert.kind];
      let basic = this.kinds[insert.kind];

      let price = parseFloat(cfg.price);
      for (var p in insert.params) {
        var n = insert.params[p];
        if (n) {
          system.cfg.cfg.params.forEach((param) => {
            param.values.forEach((v) => {
              if ((Array.isArray(n) && n.includes(v.symbol)) || v.symbol == n) {
                price += parseFloat(v.price);
              }
            });
          });
        }
      }
      if (basic.cyl1) {
        price +=
          Math.ceil((parseInt(insert.cyl1) - parseInt(cfg.cyl1_from)) / 5) *
          parseFloat(system.cfg.cfg.part_price);
      }
      if (basic.cyl2) {
        price +=
          Math.ceil((parseInt(insert.cyl2) - parseInt(cfg.cyl2_from)) / 5) *
          parseFloat(system.cfg.cfg.part_price);
      }

      return price * qty;
    },
    calcInsertSymbol(insert, system) {
      system = system || this.system;
      let kind = system.cfg.kinds[insert.kind];
      let symbol = system.cfg.reference + "-" + kind.symbol;
      /*if (this.kinds[insert.kind].cyl1) {
                symbol += '-' + insert.cyl1
                if (this.kinds[insert.kind].cyl2) {
                    symbol += '/' + insert.cyl2
                }
            }*/
      for (var i in insert.params) {
        if (insert.params[i]) {
          if (Array.isArray(insert.params[i])) {
            if (insert.params[i].length) {
              symbol += "-" + insert.params[i].join("-");
            }
          } else {
            symbol += "-" + insert.params[i];
          }
        }
      }
      return symbol;
    },
    calcKeySymbol(key, system) {
      system = system || this.system;
      let symbol = system.cfg.reference + "-" + key.symbol;
      return symbol;
    },

    calcKeyQty(key) {
      let sum = 0;
      for (var a in key.variants) {
        let n = parseInt(key.variants[a]);
        if (n > 0) {
          sum += n;
        }
      }
      return sum;
    },
    prepareIndividual(direction) {
      for (var i in this.model.keys) {
        this.qtyInd(i, direction);
      }
    },
    generateModel(model, height, width) {
      model.variants = model.variants || {};
      model.keys = model.keys || {};
      for (var i = 0; i < height; i++) {
        if (!model.keys[i]) {
          model.keys[i] = {
            name: null,
            qty: 1,
            ind: null,
            indPrice: null,
            cyl1: 30,
            cyl2: 30,
            kind: "double_cylinder",
            variants: {},
          };
        } else {
          model.keys[i].ind = model.keys[i].ind || null;
          model.keys[i].indPrice = model.keys[i].indPrice || null;
        }
        for (var a = 0; a < width; a++) {
          if (typeof model.keys[i].variants[a] != "boolean") {
            model.keys[i].variants[a] = a == 0;
          }

          if (typeof model.variants[a] != "object") {
            model.variants[a] = {
              symbol: a == 0 ? "GHS" : "G." + a,
              name: a == 0 ? "główny" : "",
              qty: 1,
            };
          }
        }
        for (var a in model.keys[i].variants) {
          if (a >= width) {
            delete model.keys[i].variants[a];
          }
        }
      }
      for (var i in model.keys) {
        if (i >= height) {
          delete model.keys[i];
          continue;
        }
        for (var a in model.keys[i]) {
          if (a >= width) {
            delete model.keys[i].variants[a];
          }
        }
      }
      for (var a in model.variants) {
        if (a >= width) {
          delete model.variants[a];
        }
      }

      return model;
    },
    variantCount(i, inc) {
      this.model.variants[i].qty = parseInt(this.model.variants[i].qty) + inc;
    },
    qty(i, inc) {
      this.model.keys[i].qty = parseInt(this.model.keys[i].qty) + inc;
    },
    qtyInd(i, inc) {
      if (this.model.keys[i].ind === null) {
        if (inc < 0) {
          return;
        } else {
          this.model.keys[i].ind = 0;
        }
      } else if (parseInt(this.model.keys[i].ind) == 0) {
        if (inc < 0) {
          this.model.keys[i].ind = null;
        } else {
          this.model.keys[i].ind = 1;
        }
      } else {
        this.model.keys[i].ind = parseInt(this.model.keys[i].ind) + inc;
      }
    },
    removeCol() {
      this.insertsVariants--;
      this.refreshModel();
    },
    addCol() {
      this.insertsVariants++;
      this.refreshModel();
    },
    removeRow() {
      this.insertsNum--;
      this.refreshModel();
    },
    addRow() {
      this.insertsNum++;
      this.refreshModel();
    },
    refreshModel() {
      this.insertsNum = Math.max(this.insertsNum, 1);
      this.insertsVariants = Math.max(this.insertsVariants, 1);

      this.model = this.generateModel(
        JSON.parse(JSON.stringify(this.model)),
        this.insertsNum,
        this.insertsVariants
      );
      console.log(this.insertsNum);
      console.log(this.insertsVariants);
    },
    rewriteModel() {
      let width = 0;
      let height = 0;
      let enabled = {};
      for (var i in this.model.keys) {
        let w = 0,
          h = 0,
          any = false;
        for (var a in this.model.keys[i].variants) {
          if (
            this.model.keys[i].variants[a] &&
            parseInt(this.model.keys[i].qty) >= 0 &&
            parseInt(this.model.variants[a].qty) >= 0
          ) {
            any = true;
            enabled[a] = true;
          }
          if (parseInt(this.model.keys[i].ind) > 0) {
            any = true;
          }
        }
        if (any) {
          height++;
        }
      }
      for (var i in enabled) {
        enabled[i] = width;
        width++;
      }

      let newModel = this.generateModel({}, height, width);
      height = 0;
      for (var i in this.model.keys) {
        let w = 0,
          h = 0,
          any = false;
        for (var a in this.model.keys[i].variants) {
          if (
            this.model.keys[i].variants[a] &&
            parseInt(this.model.keys[i].qty) >= 0 &&
            parseInt(this.model.variants[a].qty) >= 0
          ) {
            any = true;
          }
        }
        if (any) {
          newModel.keys[height] = { ...this.model.keys[i] };
          newModel.keys[height].variants = {};
          for (var a in enabled) {
            newModel.keys[height].variants[enabled[a]] =
              this.model.keys[i].variants[a];
          }

          height++;
        }
      }
      for (var a in enabled) {
        newModel.variants[enabled[a]] = this.model.variants[a];
      }
      return newModel;
    },
    step2() {
      let any = false;
      for (var i in this.model.keys) {
        for (var a in this.model.keys[i].variants) {
          if (
            this.model.keys[i].variants[a] &&
            parseInt(this.model.keys[i].qty) > 0 &&
            parseInt(this.model.variants[a].qty) > 0
          ) {
            any = true;
          }
        }
      }
      if (!any) {
        this.error = "Nie wybrano żadnego wariantu";
      } else {
        let rewritten = this.rewriteModel();
        axios
          .post(window.location, {
            step: 2,
            model: rewritten,
          })
          .then((resp) => {
            this.step = 2;
            this.cfg = resp.data;
            this.model = rewritten;
            this.insertsNum = Object.keys(rewritten.keys).length;
            this.insertsVariants = Object.keys(rewritten.variants).length;
            this.helps = { ...this.helps, ...resp.data.helps };
            this.refreshHelp(this.insertsNum, this.insertsVariants);
          })
          .catch((e) => {
            if (e.response && e.response.data.message) {
              this.error = e.response.data.message;
            } else {
              this.error = "Błąd połączenia";
            }
            this.step = 1;
          });
      }
    },
    step1() {
      this.step = 1;
      this.refreshHelp();
    },
    step3(conf) {
      let system = this.prepareSystem(conf);
      this.step = 3;
      this.system = system;
      this.calcAllPrice(system);
      this.refreshHelp();
    },
    refreshHelp() {
      if (this.helps) {
        document.getElementById("configurator-help").innerHTML =
          this.helps["page" + this.step];
      }
    },
    prepareSystem(conf) {
      let system = { cfg: conf, inserts: {}, keys: {} };
      let enabled = {};
      //console.log(this.model)
      // console.log(conf.model)
      let model = conf.model;

      for (var i in model.keys) {
        let w = 0,
          h = 0,
          any = false;
        for (var a in model.keys[i].variants) {
          if (
            model.keys[i].variants[a] &&
            parseInt(model.keys[i].qty) >= 0 &&
            parseInt(model.variants[a].qty) >= 0
          ) {
            any = true;
            enabled[a] = model.variants[a];
          }
          if (model.keys[i].ind !== null) {
            any = true;
          }
        }
        if (any) {
          system.inserts[i] = { ...model.keys[i], params: {}, order: true };
          system.cfg.cfg.params.forEach((v, p) => {
            system.inserts[i].params[p] = v.multiple ? [] : null;
          });
        }
      }

      for (var a in enabled) {
        system.keys[a] = { ...enabled[a], variants: {}, order: true };
        system.keys[a].variants[0] = enabled[a].qty;
      }
      let n = 1;

      return system;
    },

    systemOrder() {
      let orderModel = {
        id_product: this.system.cfg.id,
        keyMatrix: {},
        inserts: {},
        keys: {},
        price: this.system.price,
      };
      for (let keyId in this.system.keys) {
        let key = this.system.keys[keyId];
        let userKey = {
          reference: key.reference,
          order: key.order,
          price: key.price,
          name: key.name,
          symbol: key.symbol,
          variants: [],
          open: {},
        };
        for (let variantId in key.variants) {
          if (key.variants[variantId] > 0) {
            if (this.system.cfg.cfg.keys[variantId]) {
              userKey.variants.push({
                reference:
                  key.reference +
                  "-" +
                  this.system.cfg.cfg.keys[variantId].symbol,
                symbol: this.system.cfg.cfg.keys[variantId].symbol,
                qty: key.variants[variantId],
                name: this.system.cfg.cfg.keys[variantId].name,
                price: this.system.cfg.cfg.keys[variantId].price,
              });
            } else {
              userKey.variants.push({
                reference: key.reference + "-ST",
                symbol: "ST",
                qty: key.variants[variantId],
                name: "ST",
                price: "",
              });
            }
          }
        }
        orderModel.keys[keyId] = userKey;
      }

      for (let insertId in this.system.inserts) {
        let insert = this.system.inserts[insertId];
        let userInsert = {
          cyl1: this.kinds[insert.kind].cyl1 ? insert.cyl1 : null,
          cyl2: this.kinds[insert.kind].cyl2 ? insert.cyl2 : null,
          kind: insert.kind,
          reference: insert.reference,
          order: insert.order,
          ind: insert.ind,
          price: insert.price,
          name: insert.name,
          qty: insert.qty,
          options: [],
          open: {},
        };
        for (let paramId in insert.params) {
          if (insert.params[paramId]) {
            if (insert.params[paramId].forEach) {
              insert.params[paramId].forEach((p) => userInsert.options.push(p));
            } else {
              userInsert.options.push(insert.params[paramId]);
            }
          }
        }
        orderModel.keyMatrix[insertId] = {};
        for (let keyId in insert.variants) {
          userInsert.open[keyId] = insert.variants[keyId];
          orderModel.keys[keyId].open[insertId] = insert.variants[keyId];
          orderModel.keyMatrix[insertId][keyId] = insert.variants[keyId];
        }
        orderModel.inserts[insertId] = userInsert;
      }
      axios
        .post(window.location, {
          step: 3,
          model: orderModel,
        })
        .then((resp) => {
          prestashop.emit("updateCart", { reason: resp.data, resp: resp });
          if (resp.data.url) {
            //window.location = resp.data.url
          }
        })
        .catch((e) => {
          if (e.response && e.response.data.message) {
            this.error = e.response.data.message;
          } else {
            this.error = "Błąd połączenia";
          }
        });
    },
  },
};
</script>
<style lang="scss">
#configurator-selector {
  background: black;
  display: flex;
  li {
    padding: 10px;
    color: white;
    text-align: center;
    flex: 1;
    border-right: 1px solid white;
    &:last-child {
      border-right: 0px;
    }

    a {
      font-weight: bold;
      color: white;
      &:hover {
        text-decoration: underline;
      }
    }
  }
}
#configurator-types,
#configurator-sizes {
  display: none;
}

.info-modal .modal-container {
  width: 800px !important;
}
</style>
<style scoped lang="scss">
.system-table {
  .system {
    display: flex;
    border-bottom: 1px solid #eeeeee;
    > div {
      padding: 5px;
      flex-shrink: 0;
    }
    .photo {
      width: 60px;
    }
    .name {
      width: 350px;
    }
    .description {
      flex: 1;
    }
    .time {
      width: 110px;
    }
    .action {
      width: 130px;
    }
    .price {
      width: 100px;
      white-space: nowrap;
      text-align: right;
    }
  }
  .header {
    background: black;
    color: #a8a8a8;
    > div {
      padding: 10px 5px;
      font-size: 12px;
    }
  }
  .r {
    align-items: center;
  }
  .r .name {
  }
  .r:nth-child(odd) {
    background: #f8f8f8;
  }
}
.error {
  text-align: center;
  font-weight: bold;
}
.r-head .btns {
  padding-left: 20px;
}
.configurator {
  padding-top: 10px;
  .r {
    display: flex;
    > .middle {
      flex: 1;
      padding: 0px 5px;
    }
  }
  .btns {
    a {
      color: white !important;
      display: inline-block;
      margin: 1px;
      min-width: 20px;
      box-sizing: border-box;
      padding: 0px 5px;
      text-align: center;
      line-height: 20px;
      background: #ea8223;
      text-decoration: none !important;
    }
  }
  .btn {
    color: white !important;
    display: inline-block;
    margin: 1px;
    min-width: 20px;
    box-sizing: border-box;
    padding: 0px 10px;
    text-align: center;
    line-height: 20px;
    background: #ea8223;
    font-size: 14px;
    &:hover {
      opacity: 0.8;
    }
  }
  .step1 {
    display: flex;
    &.collapsed {
      > .left {
        width: 180px;
        .qty,
        .depth,
        .kind {
          display: none !important;
        }
      }
    }
    > .left {
      width: 650px;
      .r-head {
        line-height: 26px;
        background: #eeeeee;
        > div {
          background: black;
          color: #a8a8a8;
          border-right: 1px solid #ccc;
          padding: 0px 4px;
          padding-top: 26px;
        }
        .num {
          text-align: right;
          color: black;
          background: #eeeeee;
        }
        .individual {
          font-size: 12px;
        }
        .qty {
          padding-top: 14px;
          padding-left: 0px;
          padding-right: 0px;
          .middle {
            line-height: 1.2em;
          }
          .inserts {
            padding-top: 15px;
          }
        }
      }
      .num {
        width: 30px;
        text-align: right;
        font-size: 12px;
        padding-right: 5px;
        box-sizing: border-box;
      }
      .qty {
        width: 210px;
        flex-shrink: 0;
        text-align: center;
        .inserts {
          width: 90px;
          flex: none;
        }
        .individual {
          width: 120px;
          flex: none;
        }
      }
      .name {
        width: 165px;
      }
      .kind {
        width: 150px;
      }
      .depth {
        width: 130px;
        text-align: center;
        input {
          text-align: center;
        }
      }
    }

    > .middle {
      flex: 1;
      overflow: auto;
      .t-head {
        background: black;
        color: #a8a8a8;
        position: sticky;
        top: 0px;
        left: 0px;
      }
      .r-head {
        background: #f8f8f8;
        .variant {
          background: #f8f8f8;
        }
      }
    }
    > .right {
      width: 30px;
    }
    .variant {
      display: block;
      width: 65px;
      flex-shrink: 0;
      margin: 0px;
      padding: 0px 5px;
      text-align: center;
      border-right: 1px solid #eeeeee;
      &.active {
        background: #eeeeee;
      }
    }
    .t-head {
      height: 25px;
      line-height: 25px;
      text-align: center;
    }

    .gear {
      height: 20px;
      display: block;
    }
    .r-head {
      display: flex;
      height: 75px;
      font-size: 12px;
      a {
        color: #ea8223;
        display: inline-block;
      }
      input {
        font-size: 11px;
        text-align: center;
        width: 20px;
        padding: 2px 1px;
        border: 0px solid;
        border-radius: 0px;
      }
      input.txt {
        width: 55px;
        background: transparent;
      }
      input.name {
        border: 1px solid #eeeeee;
        background: white;
        margin-top: 4px;
        line-height: 19px;
        height: 19px;
      }
      .variant {
        &.active {
          background: #ccc;
        }
      }
    }
    .left .r-row {
      background: #f8f8f8;
      &.active {
        background: #ccc;
      }
      input,
      select {
        font-size: 11px;
        width: 100%;
        line-height: 20px;
        box-sizing: border-box;
        border: 1px solid #eeeeee;
      }
      a {
        color: #ea8223;
        display: inline-block;
      }
      .qty input {
        font-size: 11px;
        text-align: center;
        width: 40px;
        padding: 2px 1px;
        border: 0px solid;
        line-height: 20px;
        border-radius: 0px;
      }
    }
    .r-row {
      display: flex;
      height: 30px;
      line-height: 30px;
      border-bottom: 1px solid #eeeeee;
      .variant {
        border-bottom: 1px solid #eeeeee;
        margin-bottom: -1px;
      }
    }
  }
  .step3 {
    .key-table {
      padding-top: 10px;
      .r {
        border-bottom: 1px solid #eee;
      }
    }
    .header,
    .r {
      display: flex;
      > div {
        padding: 10px 5px;
      }
    }
    .sub-row {
      font-size: 12px;
      background: #eee;
      padding: 10px;
    }
    .header {
      border-bottom: 1px solid #eee;
      color: #a8a8a8;
      background: black;
      font-size: 12px;
    }
    input.qty {
      font-size: 11px;
      text-align: center;
      width: 20px;
      padding: 2px 1px;
      border: 1px solid #eee;
      line-height: 20px;
      border-radius: 0px;
    }
    .ind-qty {
      input.qty {
        width: 40px;
      }
    }
    .key-indyvidual {
      .name {
        span {
          font-size: 12px;
        }
        small {
          font-size: 12px;
          font-style: italic;
        }
      }
      input.qty {
        width: 40px;
      }
    }
    .left {
      flex: 1;
    }
    small {
      font-size: 12px;
      font-style: italic;
    }
    .insert .name span {
      font-size: 12px;
    }
    .key-row,
    .key-header {
      display: flex;
      > div {
        padding: 10px 5px;
      }
      .name {
        width: 500px;
      }
    }
    .key-header {
      font-size: 12px;
      background: #eee;
      margin-top: -39px;
    }

    .pos {
      width: 50px;
    }

    .name {
      width: 150px;
    }
    .conf {
      width: 550px;
    }
    .key .conf {
      width: 700px;
      padding-top: 0px;
    }
    .price {
      width: 150px;
    }
    .action {
      width: 50px;
    }
    table {
      width: 100%;
      .param {
        white-space: nowrap;
      }
      .value {
        padding-left: 5px;
        width: 100%;
      }
    }
    select {
      font-size: 14px;
      width: 100%;
      line-height: 20px;
      box-sizing: border-box;
      border: 1px solid #eeeeee;
    }
  }
}
input[type="number"] {
  -moz-appearance: textfield;
}
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.sizes select {
  text-align: center;
}
strong {
  font-weight: bold;
}
table {
  ul {
    padding-bottom: 0px;
    margin-bottom: 0px;
  }
  td {
    vertical-align: top;
  }
}
.extra {
  display: block;
  font-weight: bold;

  padding-top: 10px;
  color: #ea8223;
}
.h2 {
  color: #ea8223;
  font-weight: bold;
  padding-bottom: 10px;
  small {
    font-weight: normal;
    color: black !important;
    font-size: 18px;
    float: right;
  }
}
i.info {
  font-weight: bold;
  background: #ea8223;
  color: white;
  border-radius: 20px;
  display: inline-block;
  font-size: 16px;
  font-style: normal;
  padding: 0px;
  height: 18px;
  width: 18px;
  text-align: center;
  line-height: 18px;
  cursor: pointer;
}
</style>